function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHours, getMinutes, getSeconds, setHours, setMinutes, setSeconds } from 'date-fns';
import { leftPad } from '@cloud-sn/v-utils';
import VSelect from './select.js';
var __vue_script__ = {
  name: 'TimePickerCombobox',
  props: {
    prefixCls: String,
    value: {
      type: Date,
      required: true
    },
    format: String,
    showHour: Boolean,
    showMinute: Boolean,
    showSecond: Boolean,
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    disabledHours: Function,
    disabledMinutes: Function,
    disabledSeconds: Function,
    use12Hours: Boolean
  },
  data: function data() {
    return {};
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-combobox"), true);
    },
    hourSelect: function hourSelect() {
      var value = this.value,
          showHour = this.showHour,
          hourOptions = this.hourOptions,
          disabledHours = this.disabledHours,
          genItem = this.genItem,
          genSelect = this.genSelect;
      var hour = getHours(value);
      var disabledOpts = disabledHours && disabledHours();
      return genSelect('hour', showHour, function () {
        return hourOptions.map(function (v) {
          return genItem(v, disabledOpts);
        });
      }, function () {
        return hourOptions.indexOf(hour);
      });
    },
    minuteSelect: function minuteSelect() {
      var value = this.value,
          showMinute = this.showMinute,
          minuteOptions = this.minuteOptions,
          disabledMinutes = this.disabledMinutes,
          genItem = this.genItem,
          genSelect = this.genSelect;
      var hour = getHours(value);
      var minute = getMinutes(value);
      var disabledOpts = disabledMinutes && disabledMinutes(hour);
      return genSelect('minute', showMinute, function () {
        return minuteOptions.map(function (v) {
          return genItem(v, disabledOpts);
        });
      }, function () {
        return minuteOptions.indexOf(minute);
      });
    },
    secondSelect: function secondSelect() {
      var value = this.value,
          showSecond = this.showSecond,
          secondOptions = this.secondOptions,
          disabledSeconds = this.disabledSeconds,
          genItem = this.genItem,
          genSelect = this.genSelect;
      var hour = getHours(value);
      var minute = getMinutes(value);
      var second = getSeconds(value);
      var disabledOpts = disabledSeconds && disabledSeconds(hour, minute);
      return genSelect('second', showSecond, function () {
        return secondOptions.map(function (v) {
          return genItem(v, disabledOpts);
        });
      }, function () {
        return secondOptions.indexOf(second);
      });
    }
  },
  methods: {
    genItem: function genItem(val, disabledOpts) {
      var item = {};
      item.value = leftPad("".concat(val), 2, '0');

      if (disabledOpts && disabledOpts.indexOf(val) !== -1) {
        item.disabled = true;
      }

      return item;
    },
    genSelect: function genSelect(type, isShow, getList, getSelectedIndex) {
      return {
        type: type,
        show: isShow,
        list: getList(),
        selectedIndex: getSelectedIndex(),
        onSelect: this.onSelect.bind(this, type)
      };
    },
    onSelect: function onSelect(type, item) {
      var nVal = this.value;

      switch (type) {
        case 'hour':
          nVal = setHours(nVal, item.value);
          break;

        case 'minute':
          nVal = setMinutes(nVal, item.value);
          break;

        case 'second':
          nVal = setSeconds(nVal, item.value);
          break;

        default:
          break;
      }

      this.$emit('on-change', nVal);
    }
  },
  components: {
    VSelect: VSelect
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_vm.hourSelect.show ? _c('v-select', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "type": _vm.hourSelect.type,
      "list": _vm.hourSelect.list,
      "selected-index": _vm.hourSelect.selectedIndex
    },
    on: {
      "on-select": _vm.hourSelect.onSelect
    }
  }) : _vm._e(), _vm._v(" "), _vm.minuteSelect.show ? _c('v-select', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "type": _vm.minuteSelect.type,
      "list": _vm.minuteSelect.list,
      "selected-index": _vm.minuteSelect.selectedIndex
    },
    on: {
      "on-select": _vm.minuteSelect.onSelect
    }
  }) : _vm._e(), _vm._v(" "), _vm.secondSelect.show ? _c('v-select', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "type": _vm.secondSelect.type,
      "list": _vm.secondSelect.list,
      "selected-index": _vm.secondSelect.selectedIndex
    },
    on: {
      "on-select": _vm.secondSelect.onSelect
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "combobox.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);